import {
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  circle,
  roundRect,
  roundRect2,
} from '../../renderers';
import { lineFont } from '../../state/font';

import { GRID_GUIDE_MODAL_ACTIONS } from './gridGuideModalLayout';

const MODAL_CORNER_RADIUS = 10;
const MODAL_THEME_TINT_OPACITY = 0.1;
const BLACK_MODAL_THEME_TINT_OPACITY = 0.05;

const paintModalSurface = ({ ctx, modal, themeColor, themeName }) => {
  ctx.save();
  ctx.shadowColor = themeColor;
  ctx.shadowBlur = 6;
  ctx.shadowOffsetX = 2;
  ctx.shadowOffsetY = 2;
  roundRect2(
    ctx,
    modal.x,
    modal.y,
    modal.w,
    modal.h,
    MODAL_CORNER_RADIUS,
    'white',
    themeColor,
    2
  );
  ctx.restore();

  ctx.save();
  ctx.globalAlpha =
    themeName === 'black'
      ? BLACK_MODAL_THEME_TINT_OPACITY
      : MODAL_THEME_TINT_OPACITY;
  ctx.fillStyle = themeColor;
  roundRect(ctx, modal.x, modal.y, modal.w, modal.h, MODAL_CORNER_RADIUS);
  ctx.fill();
  ctx.restore();
};

const paintArrow = (ctx, button, action, themeColor) => {
  ctx.save();

  if (action === 'left' || action === 'right') {
    const arrowWidth = Math.min(42, button.w - (button.w >= 60 ? 24 : 12));
    const arrowHeight = Math.min(26, button.h - (button.h >= 48 ? 20 : 14));

    ctx.translate(
      button.x + (button.w - arrowWidth) / 2,
      button.y + (button.h - arrowHeight) / 2
    );

    const paintHorizontalArrow = action === 'left' ? arrowLeft : arrowRight;

    paintHorizontalArrow(
      ctx,
      arrowWidth,
      arrowHeight,
      2,
      themeColor,
      themeColor
    );
  } else {
    const arrowWidth = Math.min(28, button.w - (button.w >= 48 ? 24 : 14));
    const arrowHeight = Math.min(38, button.h - (button.h >= 48 ? 12 : 10));

    ctx.translate(
      button.x + (button.w - arrowWidth) / 2,
      button.y + (button.h - arrowHeight) / 2
    );

    const paintVerticalArrow = action === 'up' ? arrowUp : arrowDown;

    paintVerticalArrow(ctx, arrowWidth, arrowHeight, 2, themeColor, themeColor);
  }

  ctx.restore();
};

const paintModalButton = ({ ctx, button, action, active, themeColor }) => {
  roundRect2(
    ctx,
    button.x,
    button.y,
    button.w,
    button.h,
    8,
    active ? '#e5f3e7' : 'white',
    themeColor,
    2,
    true
  );

  if (action === 'done') {
    ctx.save();
    ctx.fillStyle = '#333';
    ctx.font = `bold 16px ${lineFont}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('Done', button.x + button.w / 2, button.y + button.h / 2);
    ctx.restore();

    return;
  }

  paintArrow(ctx, button, action, themeColor);
};

export const paintGridGuideModal = ({
  ctx,
  layout,
  grid,
  coordinatePlane,
  activeActions,
  themeColor,
  themeName,
  point,
}) => {
  if (coordinatePlane) {
    ctx.save();
    ctx.strokeStyle = themeColor;
    ctx.lineWidth = 2;
    ctx.strokeRect(grid.x - 1, grid.y - 1, grid.w + 2, grid.h + 2);
    ctx.restore();
  }

  paintModalSurface({
    ctx,
    modal: layout.modal,
    themeColor,
    themeName,
  });

  GRID_GUIDE_MODAL_ACTIONS.forEach(action => {
    const button = layout[action];

    if (button) {
      paintModalButton({
        ctx,
        button,
        action,
        active: activeActions[action],
        themeColor,
      });
    }
  });

  circle(ctx, point.x, point.y, 6, point.color);
};
